(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ice-grillz"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', (event) => {
  const link = event.target.closest('.ice-model-pick');
  if (!link) return;
  const wrapper = link.closest('.shopify-section');
  const select = wrapper ? wrapper.querySelector('#IceModel') : document.getElementById('IceModel');
  if (select) {
    select.value = link.dataset.model;
    select.dispatchEvent(new Event('change', { bubbles: true }));
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ice-storefront"] && !Shopify.designMode) return;
  try {
    
const purchaseForm=document.getElementById('BuyNow');
if(purchaseForm){purchaseForm.addEventListener('submit',async event=>{
 event.preventDefault();
 const button=event.submitter || purchaseForm.querySelector('button[data-action="checkout"]');
 const buttons=purchaseForm.querySelectorAll('button[type="submit"]');
 const error=purchaseForm.querySelector('.purchase-error');
 buttons.forEach(b=>b.disabled=true);error.hidden=true;
 try{
  const data=new FormData(purchaseForm);data.delete('return_to');data.delete('cart_destination');
  const response=await fetch(purchaseForm.action+'.js',{method:'POST',body:data,headers:{Accept:'application/json'}});
  if(!response.ok)throw new Error('Cart rejected');
  const destination=purchaseForm.querySelector(button.dataset.action==='cart'?'[name="cart_destination"]':'[name="return_to"]').value;
  const nextUrl=new URL(destination,location.origin);const preview=new URLSearchParams(location.search).get('preview_theme_id');if(preview&&button.dataset.action==='cart')nextUrl.searchParams.set('preview_theme_id',preview);window.location.assign(nextUrl.href);
 }catch(reason){error.hidden=false;buttons.forEach(b=>b.disabled=false);}
});}

const galleryDialog=document.querySelector('.design-dialog');
const galleryGrid=document.querySelector('.design-grid');
if(galleryDialog&&galleryGrid){
 const zooms=Array.from(galleryGrid.querySelectorAll('.design-zoom'));let active=0;let opener;
 const reduced=window.matchMedia('(prefers-reduced-motion: reduce)');
 const show=(index)=>{active=(index+zooms.length)%zooms.length;const source=zooms[active].querySelector('img');const target=galleryDialog.querySelector('img');target.src=source.src;target.alt=source.alt;galleryDialog.querySelector('.dialog-count').textContent=(active+1)+' / '+zooms.length;if(!reduced.matches)target.animate([{opacity:.25,transform:'translateX(12px)'},{opacity:1,transform:'translateX(0)'}],{duration:230,easing:'ease-out'});};
 zooms.forEach((button,index)=>button.addEventListener('click',()=>{opener=button;show(index);galleryDialog.showModal();}));
 galleryDialog.querySelector('.design-close').addEventListener('click',()=>galleryDialog.close());
 galleryDialog.addEventListener('close',()=>opener?.focus());
 galleryDialog.querySelector('[data-dialog-prev]').addEventListener('click',()=>show(active-1));galleryDialog.querySelector('[data-dialog-next]').addEventListener('click',()=>show(active+1));
 galleryDialog.addEventListener('keydown',event=>{if(event.key==='ArrowRight'){event.preventDefault();show(active+1);}if(event.key==='ArrowLeft'){event.preventDefault();show(active-1);}});
 let touchX;galleryDialog.addEventListener('touchstart',event=>{touchX=event.changedTouches[0].clientX;},{passive:true});galleryDialog.addEventListener('touchend',event=>{if(touchX===undefined)return;const delta=event.changedTouches[0].clientX-touchX;if(Math.abs(delta)>55)show(active+(delta<0?1:-1));touchX=undefined;},{passive:true});
 const current=()=>Math.round(galleryGrid.scrollLeft/(galleryGrid.clientWidth+16));
 const move=delta=>{const index=Math.max(0,Math.min(zooms.length-1,current()+delta));galleryGrid.scrollTo({left:index*(galleryGrid.clientWidth+16),behavior:reduced.matches?'auto':'smooth'});};
 document.querySelector('[data-gallery-prev]').addEventListener('click',()=>move(-1));document.querySelector('[data-gallery-next]').addEventListener('click',()=>move(1));
 galleryGrid.addEventListener('scroll',()=>{document.querySelector('.gallery-count').textContent=(current()+1)+' / '+zooms.length;},{passive:true});
 galleryGrid.addEventListener('keydown',event=>{if(event.target!==galleryGrid)return;if(event.key==='ArrowRight'){event.preventDefault();move(1);}if(event.key==='ArrowLeft'){event.preventDefault();move(-1);}});
}

const purpose=document.getElementById('request-purpose');
if(purpose){document.querySelectorAll('[data-address]').forEach(field=>field.required=false);}
document.addEventListener('keydown',event=>{if(event.key==='Escape'){document.querySelectorAll('.store-menu[open]').forEach(menu=>{menu.open=false;menu.querySelector('summary').focus();});}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
